if (!customElements.get('featured-products')) {
  customElements.define(
    'featured-products',
    class FeaturedProducts extends SliderComponent {
      constructor() {
        super();

        this.pendingVariantId = null;

        this.handleQuickAddClick = this.handleQuickAddClick.bind(this);
        this.handleCartUpdated = this.handleCartUpdated.bind(this);
        this.handleCartError = this.handleCartError.bind(this);
      }

      connectedCallback() {
        if (this.dataset.recommendationsUrl) {
          this.loadRecommendations();
          return;
        }

        super.connectedCallback();
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.recommendationsUrl);
          const text = await response.text();
          const html = document.createElement('div');
          html.innerHTML = text;
          const replacement = html.querySelector('featured-products');

          if (replacement) {
            this.replaceWith(replacement);
          }
        } catch (error) {
          console.error(error);
        }
      }

      onSliderReady() {
        this.addEventListener('click', this.handleQuickAddClick);
        document.addEventListener('cart:updated', this.handleCartUpdated);
        document.addEventListener('cart:error', this.handleCartError);
      }

      onSliderDestroy() {
        this.removeEventListener('click', this.handleQuickAddClick);
        document.removeEventListener('cart:updated', this.handleCartUpdated);
        document.removeEventListener('cart:error', this.handleCartError);
      }

      handleQuickAddClick(event) {
        const button = event.target.closest('[data-quick-add]');

        if (!button || !this.contains(button)) return;

        event.preventDefault();

        const variantId = Number.parseInt(button.dataset.variantId || '', 10);

        if (!variantId || button.disabled) return;

        this.pendingVariantId = String(variantId);
        button.disabled = true;

        document.dispatchEvent(
          new CustomEvent('cart:add', {
            bubbles: true,
            detail: { variantId, quantity: 1, openDrawer: true },
          }),
        );
      }

      handleCartUpdated() {
        this.resetPendingQuickAdd();
      }

      handleCartError() {
        this.resetPendingQuickAdd();
      }

      resetPendingQuickAdd() {
        if (!this.pendingVariantId) return;

        const button = this.querySelector(
          `[data-quick-add][data-variant-id="${this.pendingVariantId}"]`,
        );

        if (button) {
          button.disabled = false;
        }

        this.pendingVariantId = null;
      }
    },
  );
}
